import React from 'react';
import { LoyaltyProgramTier } from '@fiverr-private/loyalty_utils';
import { getContext } from '@fiverr-private/fiverr_context';
import { useRolloutContext } from '../../../contexts/RolloutContext';
import { useFreelancerPageContext } from '../../FreelancerPageContext';
import { PjmBanner, MultiBanner } from './banners';

const { PLATINUM, DIAMOND, SILVER, GOLD } = LoyaltyProgramTier;

export const UpmarketBanners = () => {
    const { inMarlinsSellerPagePjmBannerRollout, inMarlinsSellerPageMultiBannerRollout } = useRolloutContext();
    const { experience } = getContext();
    const { loyaltyData } = useFreelancerPageContext();
    const userLoyaltyTier = loyaltyData?.tier;

    const isPlatinumOrDiamond = userLoyaltyTier === PLATINUM || userLoyaltyTier === DIAMOND;
    const isSilverOrGold = userLoyaltyTier === SILVER || userLoyaltyTier === GOLD;

    if (!experience.isBusiness) return null;

    if (inMarlinsSellerPagePjmBannerRollout && isPlatinumOrDiamond) return <PjmBanner />;

    if (inMarlinsSellerPageMultiBannerRollout && isSilverOrGold) return <MultiBanner />;

    return null;
};
